declare module 'blankie'
declare module 'blipp'
